import { useEffect } from 'react';

import { headTags } from './seo';
import type { PageMeta } from './seo';

/**
 * Меняет заголовок и теги в <head> при переходах по сайту.
 *
 * Первую версию тегов кладёт в страницу сборка — по ней поисковик понимает
 * страницу без скриптов. Здесь всё то же самое, но для переходов внутри
 * витрины и для поисковиков, которые скрипты всё-таки запускают.
 * Свои теги помечаем data-seo, чтобы при смене страницы убрать старые.
 */
export function applyMeta(meta: PageMeta): void {
  document.title = meta.title;
  document.head.querySelectorAll('[data-seo]').forEach((el) => el.remove());

  for (const { tag, attrs, text } of headTags(meta)) {
    const el = document.createElement(tag);
    for (const [name, value] of Object.entries(attrs)) el.setAttribute(name, value);
    el.setAttribute('data-seo', '');
    if (text) el.textContent = text;
    document.head.appendChild(el);
  }
}

/** meta = null — данных ещё нет, теги пока не трогаем */
export function useSeo(meta: PageMeta | null): void {
  const key = meta ? JSON.stringify(meta) : null;
  useEffect(() => {
    if (meta) applyMeta(meta);
    // Сравниваем по содержимому: объект meta новый на каждой отрисовке
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
}
